import { render, staticRenderFns } from "./LayoutConfig.vue?vue&type=template&id=d2b3d6bc&scoped=true&"
import script from "./LayoutConfig.vue?vue&type=script&lang=js&"
export * from "./LayoutConfig.vue?vue&type=script&lang=js&"
import style0 from "./LayoutConfig.vue?vue&type=style&index=0&id=d2b3d6bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b3d6bc",
  null
  
)

export default component.exports